/* eslint-disable camelcase */
import React, { useState, useRef, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useNavigate } from 'react-router-dom';
import { UseMutationResult } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useDispatch } from 'react-redux';
import { useBffApi } from '../../../../hooks/useBffApi';
import { getOTP, IGetOTPResult } from '../../../../api/getOtp';
import { number } from './mobileSlice';
import { useAppSelector } from '../../../../app/hooks';
import { RootState } from '../../../../app/store';
import { AutofillState } from '../../../../encryptedDetailsSlice';
import { apiCatch } from '../../../../utils/apiCatchSentry';
import { bankMarqueeImageArray } from './Data';
import { IProps } from '../NewLandingPage';

// Imges imported
import arrowgif from '../../../../Icons/arrows.gif';
import downArrow from '../../../../Icons/icon-arrow-down.svg';
import errorImage from '../../../../images/error-icon.svg';
import Loader from '../../../Loader/Loader';

export interface bankingPartnersLogoType {
  csb: string;
  bob: string;
  sbm: string;
  sib: string;
  idfc: string;
  fed: string;
}

// added Marque and Sticky part
const MobileNumberAndMarque: React.FC<IProps> = (props: IProps) => {
  const firstInputRef = useRef<HTMLInputElement | null>(null);
  const { utm_campaign } = props.utmHeaders;
  // All State for validation and Number
  const navigate = useNavigate();
  const [mobileno, setMobileNo] = useState('');
  const [maxtries, setMaxtries] = useState(true);
  const [mobileNoValid, setMobileNoValid] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const [isFirstInputInView, setIsFirstInputInView] = useState(true);

  // Array of images

  const { mutate } = useBffApi<
    string,
    Function,
    UseMutationResult<AxiosResponse<IGetOTPResult>, AxiosError>
  >(getOTP);

  const dispatch = useDispatch();
  const encryptedInfo = useAppSelector(
    (state: RootState) => state.encryptedInfo as AutofillState,
  );

  // Regex Validation For Number
  const mobileNumberValidation = () => {
    const numberreg = new RegExp('^[5-9][0-9]*$');
    return numberreg.test(mobileno);
  };
  // input validation and State
  const handleNumberChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const isNumeric = new RegExp('^[0-9]*$');

    if (
      isNumeric.test(e.target.value) &&
      e.target.value.length <= 10
    ) {
      setMobileNo(e.target.value);
    }

    if (maxtries) {
      setMaxtries(false);
    }
    if (!mobileNoValid) {
      setMobileNoValid(true);
    }
  };

  TagManager.dataLayer({
    dataLayer: {
      page: 'phoneNumberInputNewLandingPage',
      utm_campaign,
    },
    dataLayerName: 'AuthDataLayer',
  });
  // final call for mobile number and check
  const submitFlow = () => {
    if (mobileNumberValidation() && mobileno.length === 10) {
      setIsLoading(true);
      mutate(
        {
          mobileNumber: mobileno,
          whatsappConsent: true,
          data_attributes: encryptedInfo.redirected.encryptedData,
          partner_name: encryptedInfo.redirected.partnerName,
        },
        {
          onSuccess: async (response) => {
            if (response.data.otpSent) {
              dispatch(number(mobileno));
              navigate('/onecardweb/phone-otp-confirmation', {
                state: { phoneNumber: mobileno },
              });
              setIsLoading(false);
            }
            if (response.data.maxOtpRetriesExceeded) {
              setMaxtries(true);
            }
          },
          onError: (error) => {
            apiCatch(error);
            if (error.response?.status === 500) {
              navigate('/onecardweb/error');
            }
          },
        },
      );
    } else {
      setMobileNoValid(false);
    }
  };

  // intersection observer for input div.
  useEffect(() => {
    const observer = new window.IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsFirstInputInView(true);
        } else {
          setIsFirstInputInView(false);
        }
      });
    });
    if (firstInputRef.current) {
      observer.observe(firstInputRef.current);
    }

    return () => {
      if (firstInputRef.current) {
        observer.unobserve(firstInputRef.current);
      }
    };
  }, []);

  return (
    <>
      <div className="hero-section flex justify-content-between w-full mt-16 mobile:mt-3 mobile:flex-col">
        <div className="hero-section_left w-3/5 pr-36 mobile:pr-0 flex flex-col justify-center mobile:order-2 mobile:justify-center mobile:w-full">
          <div className=" mobile:w-full mobile:flex mobile:justify-center">
            <div className="OneCard_heading-new text-6xl text-gray-300 text-left mobile:text-center mobile:text-4xl tablet:text-4xl">
              <h1 className="overflow-wrap break-word  mobile:text-gray-50 mobile:z-50 mobile:absolute mobile:font-semibold mobile:top-96 mobile:pt-10">
                Get a Free <br /> Metal Credit Card
              </h1>
            </div>
            <div className="OneCard_subheading mt-5 mb-7 mobile:text-center mobile:mt-3 ">
              <span className="text-gray-300 mobile:text-base opacity-60 ">
                Without getting away from your phone.
              </span>
            </div>
          </div>
          <div
            className={
              mobileNoValid
                ? 'input-container inline-flex bg-blue-500 items-center mobile:w-11/12 p-1 rounded-lg mobile:mx-4'
                : 'input-container inline-flex bg-red-500 items-center  p-1 rounded-lg mobile:w-11/12 mobile:mx-4'
            }
          >
            <input
              type="number"
              id="first_name"
              ref={firstInputRef}
              className="bg-black text-gray-300 text-sm rounded-lg 
                   focus:outline-none block p-2.5 w-full"
              placeholder="Apply with your Phone No."
              value={mobileno}
              onChange={handleNumberChange}
              required
            />
            <div className="arrow-container p-1 hover:cursor-pointer">
              <button
                type="button"
                className=" text-center pt-1"
                onClick={submitFlow}
              >
                {isLoading ? (
                  <Loader />
                ) : (
                  <img
                    className="transform -rotate-90 w-7"
                    src={arrowgif}
                    alt=""
                  />
                )}
              </button>
            </div>
          </div>
          <span
            className={mobileNoValid ? 'hidden' : 'text-red-600 flex'}
          >
            <span>
              <img src={errorImage} alt="warninglogo" />
            </span>
            Please enter a valid phone number.
          </span>
          <div className="termsAndConditions mt-3 mb-3 pr-14 font-manrope font-light text-sm leading-5 tracking-wider text-white opacity-40 mobile:text-center mobile:px-2">
            By signing up I agree to the
            <a
              href="https://www.getonecard.app/legal/terms/"
              target="_blank"
              rel="noreferrer"
            >
              {' '}
              <u>Terms of Use</u>{' '}
            </a>
            and{' '}
            <a
              href="https://www.getonecard.app/legal/privacy/"
              target="_blank"
              rel="noreferrer"
            >
              {' '}
              <u>Privacy Policy</u>{' '}
            </a>{' '}
            of OneCard, CIBIL, and Experian.{' '}
            {!showReadMore && (
              <button
                className="transition-opacity duration-300 ease-in-out opacity-100 hover:opacity-75 "
                type="button"
                onClick={() => setShowReadMore(true)}
              >
                <b>Read more.</b>
              </button>
            )}
            {showReadMore && (
              <div className="read-more-opened">
                <br />
                <br />I agree to OneCard’s Terms of Use and Privacy
                Policy and authorise them to communicate via SMS,
                Email and WhatsApp. I hereby request for a copy of my
                credit information and /or aggregates on my registered
                email ID or through my OneCard account, and authorise
                Experian and CIBIL to also provide the same to
                OneConsumer Pvt. Ltd. on my behalf.{' '}
                <button
                  type="button"
                  className="transition-opacity duration-300 ease-in-out opacity-100 hover:opacity-75"
                  onClick={() => setShowReadMore(false)}
                >
                  <b>Read less.</b>
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="hero-section_right w-3/5 mobile:hidden overflow-visible">
          <img
            className="scale-150  mask-image-gradient"
            src="https://www.getonecard.app/assets/apply/hero_img_full_4x.webp"
            loading="lazy"
            alt=""
          />
        </div>
        <div className="hero-section_mobile hidden mobile:block w-full mask-image-gradient" />
      </div>
      <div className=" flex justify-center">
        <p>Co-Branded Card Issuers:</p>
      </div>
      <div className="bank-symbol-marquee relative flex overflow-x-hidden fade-content mt-10 mb-48 mobile:mb-28">
        <div className="animate-marquee flex align-middle justify-evenly whitespace-nowrap">
          {bankMarqueeImageArray.map((image, index) => {
            return (
              <div
                className={
                  index < 3
                    ? 'grayscale-filter mobile:visible'
                    : 'grayscale-filter visible mobile:hidden'
                }
                key={image.id}
              >
                <img
                  src={image.image}
                  className="w-4/6"
                  loading="lazy"
                  alt=""
                />
              </div>
            );
          })}
        </div>

        <div className="absolute top-0 flex align-middle justify-evenly animate-marquee2 whitespace-nowrap ">
          {bankMarqueeImageArray.map((image, index) => {
            return (
              <div
                className={
                  index < 3
                    ? 'grayscale-filter mobile:visible'
                    : 'grayscale-filter visible mobile:hidden'
                }
                key={image.id}
              >
                <img
                  src={image.image}
                  className="w-4/6"
                  loading="lazy"
                  alt=""
                />
              </div>
            );
          })}
        </div>

        {/* Stcky part for floating input */}
        <div
          className={
            isFirstInputInView
              ? 'hidden'
              : 'fixed bottom-0 flex mobile:w-full mobile:pr-6 mobile:flex mobile:justify-center w-10/12 h-36  pt-3 z-50  mobile:bg-gradient-to-t from-black'
          }
        >
          <section className="sticky-input-container flex w-full h-36 justify-center p-1 rounded-xl ">
            <div className=" w-3/5 mobile:w-full flex shadow-fx bg-282828 h-3/4 rounded-2xl items-center">
              <div className="w-1/2 mobile:w-full flex flex-col justify-center items-center px-6 pr-6">
                <div
                  className={
                    mobileNoValid
                      ? 'sticky-input flex justify-center w-full bg-black py-2 h-14 rounded-lg'
                      : 'sticky-input flex justify-center w-full bg-black border-2 border-red-500 py-2 h-14 rounded-lg'
                  }
                >
                  <input
                    type="number"
                    id="first_name"
                    className=" bg-black text-gray-300 text-sm
                  block w-4/5 focus:outline-none"
                    placeholder="Apply with your Phone No."
                    value={mobileno}
                    onChange={handleNumberChange}
                    required
                  />
                  <span
                    className={
                      mobileNoValid
                        ? ' bg-313131 pt-1 rounded-lg p-2'
                        : 'bg-red-600 pt-1 rounded-lg p-2'
                    }
                  >
                    <button
                      type="button"
                      className=" text-center"
                      onClick={submitFlow}
                    >
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <img
                          className="transform -rotate-90 w-7"
                          src={downArrow}
                          alt=""
                        />
                      )}
                    </button>
                  </span>
                </div>
                <span
                  className={
                    mobileNoValid ? 'hidden' : 'text-red-600 flex'
                  }
                >
                  <span>
                    <img src={errorImage} alt="warninglogo" />
                  </span>
                  Please enter a valid phone number.
                </span>
              </div>
              <div className=" mobile:hidden w-1/2 relative">
                <img
                  src="https://www.getonecard.app/assets/apply/cropped_card.png"
                  alt="cropImage"
                  className="bottom-card rounded-br-lg"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default MobileNumberAndMarque;
